export const customers = {
  title: 'Ügyfelek',
  subtitle: 'Ügyfelek kezelése és áttekintése',
  new: 'Új ügyfél',
  view: 'Ügyfél adatlapja',
  export: 'Exportálás CSV',
  fields: {
    name: 'Név',
    contact: 'Kapcsolat',
    organizations: 'Összes szervezet',
    status: 'Státusz',
    notes: 'Megjegyzések',
    actions: 'Műveletek',
    companyName: 'Cégnév',
    companyAddress: 'Cég címe',
    taxNumber: 'Adószám',
    registrationNumber: 'Cégjegyzékszám',
    bankAccount: 'Bankszámlaszám',
    additionalPods: 'További POD-ok',
    pod: 'POD',
    firstName: 'Keresztnév',
    lastName: 'Vezetéknév',
    type: 'Típus',
    email: 'Email',
    phone: 'Telefon',
    createdAt: 'Létrehozva',
    updatedAt: 'Frissítve',
    createdBy: 'Létrehozta',
    snapshot: 'Adat pillanatkép',
    representativeName: 'Képviselő neve',
    contractNumber: 'Szerződésszám',
    contactPerson: 'Kapcsolattartó',
    financialContact: 'Pénzügyi kapcsolattartó',
    consumptionData: 'Fogyasztási adatok',
    contractPeriod: 'Szerződési időszak',
    offerPrice: 'Ajánlati ár',
    kat: 'KÁT'
  },
  registration: {
    title: 'Csatlakozzon hozzánk!',
    subtitle: 'Töltse ki az alábbi űrlapot, és hamarosan felvesszük Önnel a kapcsolatot. Professzionális ügyfélkezelő rendszerünkkel egyszerűsítjük együttműködésünket.',
    successTitle: 'Sikeres regisztráció!',
    successMessage: 'Köszönjük regisztrációját! Hamarosan felvesszük Önnel a kapcsolatot.',
    confirmationEmail: '',
    submit: 'Regisztráció küldése',
    submitting: 'Küldés...',
    privacy: 'A regisztrációval elfogadja az',
    privacyLink: 'adatvédelmi tájékoztatónkat',
    privacyEnd: '.',
    types: {
      individual: 'Magánszemély',
      organization: 'Cég'
    },
    fields: {
      customerType: 'Ügyfél típusa',
      firstName: 'Keresztnév',
      lastName: 'Vezetéknév',
      companyName: 'Cégnév',
      taxNumber: 'Adószám',
      registrationNumber: 'Cégjegyzékszám',
      email: 'Email cím',
      companyEmail: 'Cég e-mail címe',
      phone: 'Telefonszám',
      address: 'Cím',
      city: 'Város',
      postalCode: 'Irányítószám',
      country: 'Ország',
      contactPersonName: 'Kapcsolattartó neve',
      contactPersonEmail: 'Kapcsolattartó email',
      contactPersonPhone: 'Kapcsolattartó telefon',
      contactPersonPosition: 'Beosztás',
      contactPersonFax: 'Fax',
      bankAccount: 'Bankszámlaszám',
      message: 'Üzenet / Megjegyzés'
    },
    placeholders: {
      firstName: 'Keresztnév',
      lastName: 'Vezetéknév',
      companyName: 'Cég neve',
      taxNumber: '12345678-1-23',
      registrationNumber: '01-09-123456',
      email: 'email@example.com',
      phone: '+36 30 123 4567',
      address: 'Utca, házszám',
      city: 'Város',
      postalCode: '1234',
      country: 'Magyarország',
      contactPersonName: 'Kapcsolattartó teljes neve',
      contactPersonEmail: 'kapcsolattarto@ceg.hu',
      contactPersonPhone: '+36 30 123 4567',
      contactPersonPosition: 'pl. Ügyvezető',
      contactPersonFax: '+36 1 234 5678',
      bankAccount: '12345678-12345678-12345678',
      message: 'Írja le röviden, miben segíthetünk...'
    }
  },
  status: {
    active: 'Aktív',
    inactive: 'Inaktív'
  },
  tooltips: {
    edit: 'Szerkesztés',
    delete: 'Törlés',
    addOrg: 'Szervezet hozzáadása',
    activate: 'Aktiválás',
    deactivate: 'Deaktiválás',
    viewDocuments: 'Dokumentumok megtekintése',
    generateDocument: 'Dokumentum generálása',
    view: 'Részletek megtekintése',
    publicRegistration: 'Nyilvános regisztrációs linken keresztül regisztrált',
    assignOrganizations: 'Szervezetek hozzárendelése'
  },
  messages: {
    deleteConfirm: 'Biztosan törli ezt az ügyfelet?',
    noMoreOrgs: 'Nincs több hozzáadható szervezet',
    noDocuments: 'Nincs dokumentum feltöltve ehhez az ügyfélhez',
    confirmTitle: 'Ügyfél törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt az ügyfélt?',
    deleteWarning: 'Ez a művelet nem visszavonható.',
    documentGenerationStarted: 'Dokumentum generálás elindítva:',
    draftSaved: 'A vázlat elmentve',
    draftAvailable: 'Mentett vázlat elérhető',
    draftDescription: 'Egy mentett vázlat elérhető ({{date}}). Szeretné visszaállítani?',
    draftRestore: 'Visszaállítás',
    draftDiscard: 'Elvetés',
    organizationsUpdated: 'Szervezetek sikeresen frissítve',
    organizationsUpdateFailed: 'Szervezetek frissítése sikertelen'
  },
  documentModal: {
    noDocuments: 'Nincs dokumentum feltöltve ehhez az ügyfélhez',
  },
  form: {
    title: {
      new: 'Új ügyfél létrehozása',
      edit: 'Ügyfél szerkesztése',
    },
    type: {
      title: 'Ügyfél típusa',
      individual: 'Magánszemély',
      organization: 'Szervezet'
    },
    types: {
      individual: 'Magánszemély',
      organization: 'Szervezet'
    },
    organizations: {
      title: 'Szervezetek és árazás',
      notes: 'Megjegyzések',
      notesPlaceholder: 'További megjegyzések az ügyfélről...'
    },
    existingRelationship: 'Meglévő üzleti kapcsolat',
    existingRelationshipNote: 'A "Meglévő üzleti kapcsolat" jelzés mentéskor hozzáadódik a jegyzetekhez.',
    basicInfo: {
      title: 'Alapadatok',
      firstName: 'Keresztnév',
      lastName: 'Vezetéknév',
      email: 'Email cím',
      phone: 'Telefonszám',
      companyName: 'Cégnév',
    },
    companyData: {
      title: 'Cégadatok',
      taxNumber: 'Adószám',
      registrationNumber: 'Cégjegyzékszám',
    },
    address: {
      title: 'Cím adatok',
      street: 'Utca, házszám',
      city: 'Város',
      postalCode: 'Irányítószám',
      country: 'Ország',
    },
    contractDetails: {
      title: 'Szerződés adatai',
      contractNumber: 'Szerződés száma',
      companyName: 'Cég megnevezése',
      companyAddress: 'Cég címe',
      taxNumber: 'Cég adószáma',
      registrationNumber: 'Cégjegyzékszám',
      bankAccount: 'Bankszámlaszám',
    },
    contactDetails: {
      title: 'Kapcsolattartó adatai',
      representativeName: 'Képviselő neve',
      contactName: 'Kapcsolattartó neve',
      contactEmail: 'Kapcsolattartó email',
      contactPhone: 'Kapcsolattartó telefon',
      contactFax: 'Kapcsolattartó fax',
      contactPosition: 'Kapcsolattartó beosztása',
    },
    financialContact: {
      title: 'Pénzügyi kapcsolattartó',
      name: 'Pénzügyi kapcsolattartó neve',
      email: 'Pénzügyi kapcsolattartó e-mail',
      phone: 'Pénzügyi kapcsolattartó telefon',
    },
    consumptionData: {
      title: 'Fogyasztási adatok',
      date: 'Dátum',
      dueDate: 'Fizetési határidő',
      power: 'Teljesítmény (kW)',
      profileNumber: 'Profil-szám',
      consumption: 'Fogyasztás kWh',
    },
    contractPeriod: {
      title: 'Szerződés időszaka',
      startDate: 'Szerződés kezdete',
      endDate: 'Szerződés vége',
      price: 'Szerződéses ár',
    },
    offerPrice: {
      title: 'Árajánlati ár',
      price: "Ajánlati ár HUF/kWh-EUR/MWh",
      currency: 'Valutanem',
    },
    kat: {
      title: 'KÁT',
      kat: "KÁT",
      text: "KÁT szöveg",
    },
    pod: {
      title: 'POD',
      pod: 'POD',
      address: 'Fogy.hely cím',
      measurementType: 'Távmért / Profilos',
      annualConsumption: 'MÉF / Éves mennyiség (kWh)',
    },
    additionalPods: {
      title: 'POD {{index}}',
      pod: 'POD {{index}}',
      address: 'Fogy.hely cím {{index}}',
      measurementType: 'Távmért / Profilos {{index}}',
      annualConsumption: 'MÉF {{index}} / Éves mennyiség (kWh)',

    },
    addMore: 'További mező hozzáadása',
    documents: {
      title: 'Dokumentumok',
      uploadButton: 'Dokumentum feltöltése',
      uploading: 'Feltöltés...',
      empty: 'Nincs feltöltött dokumentum',
      view: 'Megtekintés',
      delete: 'Törlés',
      selectType: 'Válasszon típust',
      selectTypeDescription: 'Válasszon egy típust a dokumentumokhoz',
      typeContract: 'Szerződés',
      typeQuotation: 'Árajánlat',
      typeOther: 'Egyéb',
    }
  },
  viewModal: {
    title: 'Ügyfél adatlapja',
    address: 'Cím',
    street: 'Utca',
    city: 'Város',
    postalCode: 'Irányítószám',
    noOrganizations: 'Nincs hozzárendelt szervezet'
  },
  assignOrganizations: 'Szervezetek hozzárendelése',
  selectOrganizations: 'Válasszon szervezeteket',
  selectedOrganizations: 'Kiválasztott szervezetek',
  noOrganizationsSelected: 'Nincs kiválasztott szervezet',
  history: {
    title: '{{name}} módosítási előzményei',
    noHistory: 'Nincs elérhető módosítási előzmény',
    noHistoryDetail: 'Ennek az ügyfélnek még nem történt módosítása, vagy a módosítási előzmények nem állnak rendelkezésre. Az új módosítások automatikusan megjelennek itt.',
    oldValue: 'Régi érték',
    newValue: 'Új érték',
    initialValue: 'Kezdeti érték',
    deletedValue: 'Törölt érték',
    created: 'Létrehozva',
    updated: 'Módosítva',
    deleted: 'Törölve',
    fieldNames: {
      firstName: 'Keresztnév',
      lastName: 'Vezetéknév',
      companyName: 'Cégnév',
      email: 'Email',
      phone: 'Telefon',
      address: 'Cím',
      taxNumber: 'Adószám',
      registrationNumber: 'Cégjegyzékszám',
      bankAccountNumber: 'Bankszámlaszám',
      isActive: 'Aktív állapot',
      status: 'Státusz',
      type: 'Típus',
      notes: 'Megjegyzések',
      documents: 'Dokumentumok',
      organizations: 'Szervezetek',
      createdBy: 'Létrehozta',
      contactPersons: 'Kapcsolattartók',
      organizationIds: 'Szervezetek'
    }
  },
  relationshipLog: {
    title: 'Ügyfélkapcsolati napló',
    noLogs: 'Nincs kapcsolati bejegyzés ehhez az ügyfélhez',
    noOpenLogs: 'Nincsenek nyitott feladatok ehhez az ügyfélhez',
    add: 'Új bejegyzés hozzáadása',
    edit: 'Bejegyzés szerkesztése',
    update: 'Bejegyzés frissítése',
    delete: 'Bejegyzés törlése',
    confirmDelete: 'Biztos benne, hogy törölni szeretné ezt a bejegyzést?',
    addSuccess: 'Bejegyzés sikeresen hozzáadva',
    addError: 'Nem sikerült hozzáadni a bejegyzést',
    editSuccess: 'Bejegyzés sikeresen frissítve',
    editError: 'Nem sikerült frissíteni a bejegyzést',
    deleteSuccess: 'Bejegyzés sikeresen törölve',
    deleteError: 'Nem sikerült törölni a bejegyzést',
    entryId: 'Bejegyzés azonosító',
    content: 'Tartalom',
    contentRequired: 'A tartalom megadása kötelező',
    customerRequired: 'Kérjük, válasszon ügyfelet',
    createdAt: 'Létrehozva',
    createdBy: 'Létrehozta',
    save: 'Bejegyzés mentése',
    cancel: 'Mégsem',
    contentPlaceholder: 'Írja be a bejegyzés tartalmát (max. 1000 karakter)...',
    maxLength: 'Maximum 1000 karakter',
    searchPlaceholder: 'Keresés ügyfél, tartalom vagy azonosító alapján...',
    noResultsFilter: 'Nincs a szűrésnek megfelelő bejegyzés',
    isOpenTask: 'Megjelölés függőben lévő feladatként',
    isOpenTaskDescription: 'Jelölje be, ha vannak függőben lévő feladatok ehhez a bejegyzéshez',
    hasOpenTasks: 'Függőben lévő feladatok',
    noOpenTasks: 'Nincsenek függőben lévő feladatok',
    pendingTaskDescription: 'Még vannak függőben lévő feladatok ehhez a bejegyzéshez',
    completedTaskDescription: 'Minden feladat befejezve ehhez a bejegyzéshez',
    statusOpen: 'Nyitott',
    statusClosed: 'Lezárt',
    filterOpenOnly: 'Csak nyitott feladatok',
    statusFilter: 'Szűrés állapot szerint'
  },
  tabs: {
    details: 'Részletek',
    relationshipLog: 'Ügyfélkapcsolati napló',
    history: 'Előzmények'
  },
  actions: {
    view: 'Megtekintés'
  }
}